import { useAppSelector } from 'store/index';

export const useHistory = () => {
    return useAppSelector(({ history: { data } }) => data);
};
